import { dataLayer, ga } from "shared"

export const trackDonateFormVisit = ({ config, display }) => {
  dataLayer.push({
    event: "eeCheckout",
    ecommerce: {
      currencyCode: "EUR",
      checkout: {
        actionField: { step: 1, option: "form loaded" },
        products: [
          {
            name: escapeHTML(display.receiverName),
            id: `${config.receiverType}#${config.receiverId}`,
            brand: display.receiverGtmBrand,
            quantity: 1,
          },
        ],
      },
    },
  })

  /**
   * What we have to keep in mind:
   * There could be more than one experiment in one GA - User Session
   * Eg, a User could donate on an iframe donation form(experiment 1)
   * and then on betterplace(experiment 2).
   * This code will(correctly) set the dimension3 each time.
   * But we configured dimension3 in the GA interface to be on
   * GA - session - level.So GA has to decide which value to assign.
   * I am pretty sure they will always use the latest value for
   * the whole session.
   */
  if (config.trackingAB) {
    ga("send", {
      hitType: "event",
      eventCategory: "beacon",
      eventAction: "set dimension3_with_ab_test_value",
      eventLabel: `value ${config.trackingAB}`,
      nonInteraction: true,
      dimension3: `${config.trackingAB}`,
    })
  }
}

// slim and temple did _some_ escaping to the ecommerce javascript. Since we
// use the receiverName to aggregate results we need to mirror that exact
// behavior.
// See https://github.com/judofyr/temple/blob/master/lib/temple/utils.rb#L42-L49
const escapeHTML = (value) =>
  value
    .replace("&", "&amp;")
    .replace('"', "&quot;")
    .replace("'", "&#39;")
    .replace("<", "&lt;")
    .replace(">", "&gt;")
